import { InjectionToken } from '@angular/core';
import { Routes } from '@angular/router';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');
export const CORE_CONFIG = new InjectionToken<CoreConfig>('CORE_CONFIG');
export const CORE_BACKEND = new InjectionToken<CoreBackendIDs>('CORE_BACKEND');
export const CORE_I18N_FOLDER = new InjectionToken<string>('CORE_I18N_FOLDER');
export const CORE_PAGE_MODULE = new InjectionToken<CorePageModule>(
  'CORE_PAGE_MODULE'
);
export const MEASURES_ICONS = {
  'bepatient-measure-model-discrete': 'bepatient-scale',
  'bepatient-model-tension': 'bepatient-tension',
  'bepatient-model-activity': 'bepatient-watch',
  'bepatient-model-misfit': 'bepatient-watch',
  'bepatient-model-activity-ihealth': 'bepatient-watch',
  'bepatient-model-blood-glucose': 'bepatient-glucose',
  'bepatient-computed-measure-model': 'bepatient-computed',
  'bepatient-model-enumerate': 'bepatient-enumerate',
  'bepatient-model-fcal': 'bepatient-fcal',
  'bepatient-scoring': 'bepatient-score',
  'bepatient-model-oxygen': 'bepatient-oxygen'
};

export enum CorePageModuleIDs {
  BODY_SCHEMA = 'Module BODY_SCHEMA',
  BRIDGE_WEBVIEW = 'Module BRIDGE_WEBVIEW',
  CATEGORY = 'Module CATEGORY',
  FACTSHEET = 'Module FACTSHEET',
  HELP = 'Module HELP',
  INSTANCE = 'Module INSTANCE',
  LOGIN = 'Module LOGIN',
  MESSAGES = 'Module MESSAGES',
  MY_ACCOUNT = 'Module MY_ACCOUNT',
  MY_FORM = 'Module MY_FORM',
  MY_FORMS_LIST = 'Module MY_FORMS_LIST',
  MY_MEASURES = 'Module MY_MEASURES',
  ONBOARDING = 'Module ONBOARDING',
  PATIENT_LIST = 'Module PATIENT_LIST',
  PATIENT_PROFILE = 'Module PATIENT_PROFILE',
  QUIZZ = 'Module QUIZZ',
  TAKE_MEASURE = 'Module TAKE_MEASURE',
  TILES_ENTRY_PAGE_MODULES = 'Module TILES_ENTRY_PAGE_MODULES',
  TIMELINE = 'Module TIMELINE',
  TOS = 'Module TOS',
  EVENTS = 'Module EVENTS',
  EDOCUMENTS = 'Module EDOCUMENTS',
  EDIARY = 'Module EDIARY',
  MENU = 'Module MENU'
}

export enum CoreBackendIDs {
  MOBI = 'Backend MOBI',
  SMART = 'Backend SMART',
  APOLLO = 'Backend APOLLO'
}

export const coreAnalyticsEvents = {
  PASSWORD_DISPLAY: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Connection',
        eventAction: 'Password display',
        eventLabel: '<extra>'
      }
    }
  },
  OPEN: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Menu',
        eventAction: 'Open',
        eventLabel: 'Open'
      }
    }
  },
  CLOSE: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Menu',
        eventAction: 'Close',
        eventLabel: 'Close'
      }
    }
  },
  LOGOUT: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Connection',
        eventAction: 'Logout',
        eventLabel: 'Logout'
      }
    }
  },
  MESSAGES_READ_NEW: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Messages',
        eventAction: 'Read New Messages',
        eventLabel: 'Read New Messages'
      }
    }
  },
  MESSAGE_SENT: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Messages',
        eventAction: 'Send messages',
        eventLabel: 'Send messages'
      }
    }
  },
  MESSAGE_ATTACHMENT: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Messages',
        eventAction: 'Attachements',
        eventLabel: 'Attach Files'
      }
    }
  },
  INSTANCE_FAIL: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Connection',
        eventAction: 'Instance Code',
        eventLabel: 'Failed'
      }
    }
  },
  INSTANCE_SUCCESS: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Connection',
        eventAction: 'Instance Code',
        eventLabel: 'Success'
      }
    }
  },
  CONNECTION_FAIL: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Connection',
        eventAction: 'Account',
        eventLabel: 'Failed'
      }
    }
  },
  PASSWORD_RESET: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Connection',
        eventAction: 'Password Reset',
        eventLabel: 'Request'
      }
    }
  },
  TWOFA_FAIL: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Connection',
        eventAction: '2FA',
        eventLabel: 'Failed'
      }
    }
  },
  ACTIONBUTTON_TAP: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Timeline',
        eventAction: 'Action Button',
        eventLabel: 'Tap'
      }
    }
  },
  MEASURE_MANUAL: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Measure',
        eventAction: 'Manual',
        eventLabel: 'Manual measure taken'
      }
    }
  },
  MEASURE_DEVICES: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Measure',
        eventAction: 'Device',
        eventLabel: 'Device measure taken'
      }
    }
  },
  MEASURE_INITIAL_RANGE: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Measure',
        eventAction: 'Device',
        eventLabel: 'Initial Range'
      }
    }
  },
  MEASURE_CHANGE_RANGE: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Measure',
        eventAction: 'Device',
        eventLabel: 'Change Range'
      }
    }
  },
  NEW_PATIENT_EVENT_ADDED: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Add',
        eventLabel: 'Event category'
      }
    }
  },
  DELETE_PATIENT_EVENT_CONFIRMATION: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Delete',
        eventLabel: 'Event category'
      }
    }
  },
  DELETE_PATIENT_EVENT_CONFIRMED: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Delete',
        eventLabel: 'Event Category'
      }
    }
  },
  PATIENT_EVENT_IS_SET_TO_ATTENDED: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Attended',
        eventLabel: 'Attended'
      }
    }
  },
  PATIENT_EVENT_IS_SET_TO_UNATTENDED: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Unattended',
        eventLabel: 'Unattended'
      }
    }
  },
  PATIENT_EVENT_EDITED: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Edit',
        eventLabel: 'Patient event edited'
      }
    }
  },
  PATIENT_EVENT_EDITED_DATE: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Edit/date',
        eventLabel: 'Patient event edited'
      }
    }
  },
  PATIENT_EVENT_EDITED_REMINDER: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Edit/reminder',
        eventLabel: 'Patient event edited'
      }
    }
  },
  PATIENT_EVENT_EDITED_QUESTION: {
    ga: {
      data: {
        hitType: 'event',
        eventCategory: 'Patient Event',
        eventAction: 'Edit/question',
        eventLabel: 'Patient event edited'
      }
    }
  }
};
export enum DevTypes {
  PROD = 'PROD',
  BETA = 'BETA',
  DEV = 'DEV'
}

export interface Environment {
  production?: boolean;
  instancesData?: CoreInstancesData;
  devType?: DevTypes;
  version?: string;
  useEncryption?: boolean;
  instance?: {
    url: string;
    code: string;
  };
  appStoreLinks?: {
    ios: string;
    android: string;
  };
  supportedDevices?: string[];
  privacyStatementUrl?: string;
}

export interface CoreInstancesData {
  prod?: CoreInstance;
  beta?: CoreInstance;
  test?: CoreInstance;
  dev?: CoreInstance;
  fixed?: boolean;
}

export interface CoreInstance {
  url: string;
  code: string;
  product_identifier?: string;
}

export type CoreInstanceEnvironment = 'PROD' | 'BETA' | 'TEST' | 'DEV';

/**
 * Objet créé après le chargement des infos de l'instance
 */
export interface CoreInstanceInfo {
  /**
   * Instance Color
   */
  instanceColor: string;
  /**
   * Instance color shade based on theme
   */
  appColor: string;
  /**
   * Version minimale de l'application
   */
  appVersionV3: string;
  /**
   * Couleur par défaut des Catégories
   */
  defaultCategoryColor: string;
  /**
   * Couleur par défaut des Fiches pratiques
   */
  defaultFactsheetColor: string;
  /**
   * Couleur par défaut des formulaires
   */
  defaultFormColor: string;
  /**
   * Couleur par défaut des Mesures
   */
  defaultMeasureColor: string;
  /**
   * Couleur par défaut des eDocuments
   */
  defaultEDocsColor: string;
  /**
   * Afficher le bouton d'action
   */
  displayActionButton: boolean;
  /**
   * Logo de l'instance (en base64)
   */
  logo: string;
  /**
   * Titre de l'instance
   */
  title: string;
  /**
   * Url de l'instance
   */
  url?: string;
  /**
   * Instance language
   */
  language?: string;
  /**
   * Email page data
   */
  login?: CoreLoginModule;
  /**
   * Password page data
   */
  password?: CorePasswordModule;
  /**
   * Instance code
   */
  instance_code?: string;
  /**
   *
   */
  isQR?: boolean;
}

/**
 * Objet créé après la phase de login
 */
export interface CoreLogin {
  /**
   * Token utilisé pour les calls API
   */
  iAuth: string;
  /**
   * ID de l'utilisateur
   */
  userId: number;
  /**
   * identifiant de connexion
   */
  loginId: string;
  /**
   * L'utilisateur est entré dans la phase Onboarding **(géré par l'application)**
   */
  userIsInOnboarding: boolean;
  /**
   * L'utilisateur a changé son mot de passe **(géré par l'application)**
   */
  userChangedPassword: boolean;
  /**
   * L'utilisateur doit changer son mot de passe
   */
  userMustChangePassword: boolean;
  /**
   * L'utilisateur doit rentrer dans la phase Onboarding
   */
  userMustEnterOnboarding: boolean;
  /**
   * UUID de l'utilisateur
   */
  uuid: string;
  /**
   * Langue de l'utilisateur (sur Authorize)
   */
  language: string;
  /**
   * Si l'utilisateur a une langue RTL (sur Authorize)
   */
  rightToLeft: boolean;
  /**
   * This field value is to run the timer
   * */
  tokenValidationCheckFrequency?: number;
  /**
   * The time limit where the popup message will starts to display
   * */
  tokenWarningExpirationDuration?: number;
  /**
   * Flag to identify user logged in using new device or older
   * */
  isNewDevice?: boolean;
  /**
   * Message for the new device popup
   * */
  popupNewDeviceMessage?: string;
  /**
   * Password reset interface
   */
  passwordResetInterface?: any;
  /**
   * This value is to return messages received from backend
   */
  message?: any;
  /**
   * Flag to identify user set trusted device or not
   * */
  disagreeTrustedDevice?: boolean;
  /**
   * Flag to identify quick tour should display or not
   * */
  isDisplayQuickTour?: boolean;
}

/**
 * Objet créé après le chargement des infos de l'utilisateur
 */
export interface CoreUser {
  /**
   * UUID de l'utilisateur
   */
  uuid: string;
  /**
   * Configuration de l'utilisateur (voir les détails dans le [code source]{@link #source} de l'objet)
   */
  configuration: {
    /**
     * Afficher les mesures dans extra
     */
    displayMeasuresInExtra: boolean;
    /**
     * L'utilisateur est un professionnel
     */
    isPro: boolean;
    /**
     * Langue de l'utilisateur
     */
    language: string;
    /**
     * Si l'utilisateur est un professionnel, alors il peut contrôler les eMails
     */
    proIsAllowedToControlMail: boolean;
    /**
     * La langue est une langue RTL
     */
    rightToLeft: boolean;
    /**
     * Format de la date
     */
    dateSettings: {
      dateFormat: string;
      timeFormat: string;
      timezone: string;
    };
    /**
     * Groupes auxquels appartient l'utilisateur
     */
    groups: Array<{ uuid: string; title: string }>;
    /**
     * Date d'inscription de l'utilisateur
     */
    registrationDate: string;
  };
  /**
   * Informations de l'utilisateur (voir les détails dans le [code source]{@link #source} de l'objet)
   */
  personal: {
    /**
     * Date de naissance de l'utilisateur
     */
    birthdate: string;
    /**
     * eMail de l'utilisateur
     */
    email: string;
    /**
     * Surnom de l'utilisateur
     */
    nickname: string;
    /**
     * Présentation de l'utilisateur
     */
    presentation: string;
  };
}

/**
 * Objet créé après le chargement du menu de l'utilisateur
 */
export interface CoreMenu {
  /**
   * Couleur principale du menu **(gérée par l'application)**
   */
  color: string;
  /**
   * Logo en l'instance (en base64) **(géré par l'application)**
   */
  instanceLogo: string;
  /**
   * Boutons principaux du menu (voir les détails dans le [code source]{@link #source} de l'objet)
   */
  mainButtons: Array<{
    /**
     * ID du bouton
     */
    id:
      | 'home'
      | 'messages'
      | 'measures'
      | 'myMeasures'
      | 'events'
      | 'myFiles'
      | 'eDiary';
    /**
     * Couleur de l'icône du bouton
     */
    iconColor: string;
    /**
     * Nombre de notifications du boutons
     */
    notifications?: number;
  }>;
  /**
   * Groupes de boutons secondaires du menu (voir les détails dans le [code source]{@link #source} de l'objet)
   */
  secondaryButtonGroups: Array<{
    /**
     * Titre du groupes
     */
    title?: string;
    /**
     * Tableau de la liste des boutons du groupe
     */
    buttons: Array<{
      /**
       * Titre du bouton
       */
      label: string;
      /**
       * Resource associée au bouton
       */
      resource: CoreMobiResource;
    }>;
  }>;
}

export interface CoreLoginModule {
  buttonLabel: string;
  changeProgramLabel: string;
  forgotIdLabel: string;
  forgotIdPopup: string;
  title: string;
}

export interface CorePasswordModule {
  buttonLabel: string;
  forgotPasswordLabel: string;
  newPasswordButtonLabel: string;
  title: string;
}

export interface CorePageModule {
  ID: CorePageModuleIDs;
  icon?: string;
  i18nLabel?: string;
  routes: Routes;
  leftMenuAvailableForPages?: Array<number>;
  rightMenuAvailableForPages?: Array<number>;
  leftMenuAvailableForDepthModules?: boolean;
  rightMenuAvailableForDepthModules?: boolean;
}

/**
 * Objet de configuration d'une application
 */
export interface CoreConfig {
  /**
   * Liste des modules disponibles dans le menu (si menu statique)
   */
  entryPageModules?: Array<CorePageModuleIDs>;
  /**
   * Infos de des instances si il s'agit une instance fixe
   */
  instancesData?: CoreInstancesData;
  /**
   * Restreindre l'application à un patient ou un professionnel
   */
  restrictAppTo?: 'patient' | 'pro';
  /**
   * Premier module affiché après la connection
   */
  rootPageModule: CorePageModuleIDs;
  /**
   * Afficher le spinner automatiquement à chaque requête HTTP
   */
  useGlobalLoading?: boolean;
}

export enum CoreMobiResourceType {
  BODY_SCHEMA,
  CATEGORY,
  FACTSHEET,
  FORM,
  QUIZZ,
  CHATBOT,
  MEASURE,
  HTML,
  ECONSENT,
  WEBVIEW,
  DEEPLINK
}

/**
 * Objet d'une resource MOBI
 */
export interface CoreMobiResource {
  /**
   * Type de la resource
   */
  type: CoreMobiResourceType;
  /**
   * href de la resource
   */
  href: string;
}

export interface CoreResourceStackItem {
  type?: CoreMobiResourceType;
  href?: string;
  color?: string;
  title?: string;
  toUrl?: string;
  fromUrl?: string;
}

export interface CoreResourceFormOverride {
  icon: string;
  color: string;
}

export interface CoreMeasure {
  icon: string;
  color: string;
  title: string;
  lastEntry: string;
  lastEntryLabel: string;
  activityId: string;
  activityModelId: string;
  device?: { name: string; title: string; useExtra: boolean };
  fields: Array<{
    key: string;
    unit: string;
    title: string;
    minValue?: number;
    maxValue?: number;
    minValueIndicative?: number;
    maxValueIndicative?: number;
  }>;
  subType: string;
  isManualMeasure: boolean;
  uuid: string;
}

export interface CoreInAppNotification {
  title: string;
  content: string;
}
/**
 * Tri-state of the in-app biometric login preference.
 * - `'true'`     enabled by the user
 * - `'false'`    turned off by the user (does not auto-recover)
 * - `'disabled'` blocked by the OS/permission state (auto-recovers when biometric becomes available again)
 */
export type BiometricLoginState = 'true' | 'false' | 'disabled';

/**
 *
 */
export interface CoreBiometricData {
  /**
   * type of biometric available
   * set 'finger' | 'face' | 'biometric'
   */
  biometricType: string;
  /**
   * Status of biometric enabled in App
   * 'true' | 'false' | 'disabled'
   */
  enableBiometricLogin: BiometricLoginState;
  /**
   * Status of biometric secret stored in Keychain by App
   * 'true' | 'false'
   */
  keychainEnrolled: string;
  /**
   * Status of biometric finger/face enrolled in OS settings, No face/finger enrolled then set false
   * 'true' | 'false'
   */
  biometricEnrolled: string;
  /**
   * Permission allowed for APP to use biometric
   */
  permission?: string;
  /**
   * Set when the device was detected as rooted/jailbroken. Biometric login is
   * kept off while this is true so the UI can explain why it is unavailable.
   */
  deviceRooted?: boolean;
  /**
   * True when the user explicitly turned biometric login OFF via the toggle.
   * Distinguishes a deliberate opt-out (never auto-prompt/re-enroll until the
   * user turns it back on) from a fresh/undecided device (still offer the
   * one-time enrolment prompt after a password login). Cleared on re-enable
   * and on successful enrolment.
   */
  userOptedOut?: boolean;
}

/*
 * En
 */
export enum CoreInstanceOptionType {
  INSTANCE_OPTION = 'instance-option',
  INSTANCE_MANUAL = 'instance-manual',
  INSTANCE_QR = 'instance-qr',
  INSTANCE_QR_HELP = 'instance-qr-help'
}

/**
 * All pages for login options
 */
export enum CoreLoginOptionsType {
  LOGIN_OPTIONS = 'login-options',
  LOGIN_EMAIL = 'login-email',
  LOGIN_PASSWORD = 'login-password',
  LOGIN_RESET_BIRTHDAY = 'login-reset-birthday',
  LOGIN_ONBOARDING_BIRTHDAY = 'login-onboarding-birthday'
}

/**
 * Quick Tour Step types
 *
 */
export enum CoreQuickTourStepTypes {
  INTRO = 'intro',
  TIMELINE = 'timeline',
  MENU = 'menu',
  ACCOUNT = 'account'
}
